import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setTranscriptions as setTranscriptionsAction } from "../../../actions/configurationActions";
import axios from "axios";

interface FetchTranscriptDataProps {
    showTranscriptSettings: boolean;
}

interface TranscriptionData {
    entries: any;
    language: string;
    translationLanguages?: string[];
    translations?: any[]
}


export const useFetchTranscriptData = ({ showTranscriptSettings }: FetchTranscriptDataProps): { transcriptions?: TranscriptionData } => {
    const dispatch = useDispatch();
    const { currentMediaId, accountId } = useSelector((state) => (state as any).configurationReducer);

    const [transcriptions, setTranscriptions] = useState<TranscriptionData | undefined>(undefined);

    useEffect(() => {
        if (!showTranscriptSettings || !currentMediaId || !accountId) {
            dispatch(setTranscriptionsAction({}));
            setTranscriptions(undefined);
            return;
        }

        const transcriptionUrl = `https://video.qbrick.com/api/v1/text/public/accounts/${accountId}/medias/${currentMediaId}/transcription`
        axios.get(transcriptionUrl).then((response) => {
            if (response?.data) {
                dispatch(setTranscriptionsAction(response?.data));
                setTranscriptions(response?.data);
            } else {
                dispatch(setTranscriptionsAction({}));
                setTranscriptions(undefined);
            }
        }).catch(() => {
            dispatch(setTranscriptionsAction({}));
            setTranscriptions(undefined);
        });
    }, [accountId, currentMediaId, dispatch, showTranscriptSettings]);

    return { transcriptions };
}